module.exports = [
  {
    "COD": "Drug Poisoning",
    "Geography": "Metro New Orleans",
    "Year": "1999-2001",
    "Rate": 5.6
  },
  {
    "COD": "Drug Poisoning",
    "Geography": "Metro New Orleans",
    "Year": "2002-2004",
    "Rate": 11.33
  },
  {
    "COD": "Drug Poisoning",
    "Geography": "Metro New Orleans",
    "Year": "2005-2007",
    "Rate": 20.03
  },
  {
    "COD": "Drug Poisoning",
    "Geography": "Metro New Orleans",
    "Year": "2008-2010",
    "Rate": 14.67
  },
  {
    "COD": "Drug Poisoning",
    "Geography": "Metro New Orleans",
    "Year": "2011-2013",
    "Rate": 19.17
  },
  {
    "COD": "Drug Poisoning",
    "Geography": "Metro New Orleans",
    "Year": "2014-2016",
    "Rate": 25.83
  },
  {
    "COD": "Drug Poisoning",
    "Geography": "Metro New Orleans",
    "Year": "2017-2018",
    "Rate": 33.95
  },
  {
    "COD": "Drug Poisoning",
    "Geography": "United States",
    "Year": "1999-2001",
    "Rate": 4.23
  },
  {
    "COD": "Drug Poisoning",
    "Geography": "United States",
    "Year": "2002-2004",
    "Rate": 6.27
  },
  {
    "COD": "Drug Poisoning",
    "Geography": "United States",
    "Year": "2005-2007",
    "Rate": 8.5
  },
  {
    "COD": "Drug Poisoning",
    "Geography": "United States",
    "Year": "2008-2010",
    "Rate": 9.43
  },
  {
    "COD": "Drug Poisoning",
    "Geography": "United States",
    "Year": "2011-2013",
    "Rate": 10.83
  },
  {
    "COD": "Drug Poisoning",
    "Geography": "United States",
    "Year": "2014-2016",
    "Rate": 14.33
  },
  {
    "COD": "Drug Poisoning",
    "Geography": "United States",
    "Year": "2017-2018",
    "Rate": 18.65
  }
]
